<div class="flex align-items-center justify-content-center w-full font-bold border-round m-2 text-3xl title-case">
    Audit Trail / Transaction Log
</div>
<p-card>
    <form [formGroup]="filterDataForm">
        <div class="grid">
            <div class="col-12 md:col-6 lg:col-3">
                <label for="QueryType" class="required-field">Query Type : </label>
                <div>
                    <p-dropdown [options]="queryType" optionLabel="name" formControlName="queryType"
                        placeholder="Select Query Type" styleClass="w-9" name="queryType" (onChange)="onChangeQuery($event)">
                    </p-dropdown>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3" *ngIf="filterDataForm.value.queryType.name === 'Transactions'">
                <label for="partnerId" class="">Partner ID : </label>
                <div>
                    <p-dropdown name="partnerId" placeholder="ALL" styleClass="w-9" [showClear]="true"
                        [options]="partnerDetails" optionLabel="partnerId" optionValue="partnerId"  formControlName="partnerId" [filter]="true">
                    </p-dropdown>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <label for="eventType" class="">Event : </label>
                <div>
                    <p-dropdown name="eventType" placeholder="Select Event" styleClass="w-9" [showClear]="true"
                        formControlName="eventType" [options]="allEventTypes" optionValue="name" optionLabel="name" [filter]="true">
                    </p-dropdown>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <label for="action" class="">Action : </label>
                <div>
                    <p-dropdown name="action" [options]="allEventActions" placeholder="Select Action" styleClass="w-9"
                        formControlName="action" optionValue="name" optionLabel="name" [showClear]="true" [filter]="true">
                    </p-dropdown>
                </div>
            </div>

            <div class="col-12 md:col-6 lg:col-3" *ngIf="filterDataForm.value.queryType.name === 'Transactions'">
                <label for="status" class="">Status : </label>
                <div>
                    <p-dropdown formControlName="status" placeholder="select status" styleClass="w-9"
                        [options]="statusList" optionLabel="name" optionValue="name" [showClear]="true">
                    </p-dropdown>
                </div>
            </div>

            <div class="col-12 md:col-6 lg:col-3">
                <label for="startDate" class="required-field">Start Date : </label>
                <div>
                    <p-calendar formControlName="startDate" styleClass="w-9" appendTo="body" hourFormat="24"
                        [showIcon]="true" dateFormat="MM dd yy" (onSelect)="validateStartDate($event)"
                        [maxDate]="maxScheduledStartDate" [readonlyInput]="true">
                    </p-calendar>
                </div>

            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <label for="endDate" class="">End Date : </label>
                <div>
                    <p-calendar formControlName="endDate" styleClass="w-9" appendTo="body" hourFormat="24"
                        [showIcon]="true" (onSelect)="validateEndDate($event)" dateFormat="MM dd yy"
                        [maxDate]="maxScheduledEndDate" [readonlyInput]="true" [showButtonBar]="true">
                    </p-calendar>
                </div>

                <div>
                    <span class="error-msg"  style="text-align:center">{{showMessage}}</span>
                </div>
            </div>
        </div>
        <div class="flex justify-content-center mt-2">
            <button pButton type="button" label="Display Log" (click)="displayLog()"
                [disabled]="filterDataForm.invalid || showMessage"></button>
        </div>
    </form>
</p-card>


<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle">
</p-confirmDialog>
<div class="mt-2" *ngIf="isDataAvailable && !this.norecordsFound">
    <p-card>
        <div class="flex justify-content-end mb-2">
            <button pButton type="button" label="Export" (click)="exportExcel()"></button>
        </div>
        <p-table [columns]="columnList" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
            responsiveLayout="scroll" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [value]="configurationReport" styleClass="p-datatable-striped" [lazy]="true"
            (onLazyLoad)="onLazyLoad($event)" [lazyLoadOnInit]="false" [totalRecords]="totalRecords"
            [rowsPerPageOptions]="[10,25,50]">

            <ng-template pTemplate="header" let-columns>
                <tr style="word-break: break-word;">
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="font-bold">
                        {{col.header}}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr *ngIf="filterDataForm.value.queryType.name === 'Configuration Changes'">
                    <td>{{data.logEventId}}</td>
                    <td>{{data.logEventDescription}}</td>
                    <td>{{data.logEventType}}</td>
                    <td>{{data.logEventAction}}</td>
                    <td>{{data.status}}</td>
                    <td>{{data.logEventDate | date: 'MMM dd yyyy HH:mm'}}</td>
                    <td>{{data.logEventBy}}</td>
                </tr>

                <tr *ngIf="filterDataForm.value.queryType.name === 'Transactions'">
                    <td>{{data.partnerId}}</td>
                    <td>{{data.pac}}</td>
                    <td>{{data.logEventType}}</td>
                    <td>{{data.logEventAction}}</td>
                    <td>{{data.status}}</td>
                    <td>{{data.logEventDate | date: 'MMM dd yyyy HH:mm'}}</td>
                    <td>{{data.logEventId}}</td>
                </tr>
            </ng-template>
        </p-table>
    </p-card>
</div>
<p *ngIf="norecordsFound" class="flex justify-content-center"> No Data Available</p>

<p-toast position="top-center" life="4000"></p-toast>